import React, { useContext, useEffect, useState } from "react";
import { css } from "@emotion/react";

import { devices, heights, colors } from "../assets/styles/variables";
import ViewerStateContext from "../context/viewer-state";
import { PublishedContext } from "../context/published-state";

const footer = css`
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: ${heights.footer};
  padding: 0 15px;
  color: ${colors.white};
  background-color: ${colors.black};
  border-top: 2px solid ${colors.lightgray};

  .button {
    position: relative;
    width: 30px;
    height: 30px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background-color: ${colors.white};
    outline: none;
    cursor: pointer;

    &:before {
      position: absolute;
      top: calc(50% - 4px);
      width: 8px;
      height: 8px;
      border-bottom: 2px solid ${colors.black};
      border-left: 2px solid ${colors.black};
      content: "";
    }

    &.prev:before {
      left: calc(50% - 4px);
      transform: rotate(45deg);
    }

    &.next:before {
      right: calc(50% - 4px);
      transform: rotate(-135deg);
    }

    &.hidden {
      visibility: hidden;
    }
  }

  .status {
    flex-grow: 1;
    min-width: 100px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    letter-spacing: 0.1em;

    em {
      font-style: normal;
      font-size: 24px;
    }

    @media screen and (min-width: ${devices.mobile}) {
      flex-grow: 0;
    }
  }
`;

const Footer = (props: any) => {
  const { sliderRef, length } = props;
  const viewerState = useContext(ViewerStateContext);
  const publishedState = useContext(PublishedContext)[0];
  const [stylePrevButton, setStylePrevButton] = useState("button prev hidden");
  const [styleNextButton, setStyleNextButton] = useState("button next hidden");

  useEffect(() => {
    // ナビゲーションボタンのStyle（即ち表示非表示）の制御。
    setStylePrevButton(
      viewerState.currentPage === length ? "button prev hidden" : "button prev"
    );
    setStyleNextButton(
      viewerState.currentPage === 1 ? "button next hidden" : "button next"
    );
  });

  const handleClickMoveButton = (isPrev: boolean) => {
    const sliderEl = sliderRef.current;
    if (sliderEl) {
      // rtl(Right to Left)を有効にしているため、
      // 次のページに進むためにslickPrev()を呼ぶ必要があることに注意
      isPrev ? sliderEl.slickNext() : sliderEl.slickPrev();
    }
  };

  return (
    <footer css={footer}>
      {!publishedState.late && !publishedState.soon && (
        <>
          <button
            className={stylePrevButton}
            onClick={() => handleClickMoveButton(false)}
          />
          <div className="status">
            <em>{viewerState.currentPage}</em>/{length}
          </div>
          <button
            className={styleNextButton}
            onClick={() => handleClickMoveButton(true)}
          />
        </>
      )}
    </footer>
  );
};

export default Footer;
